import React from "react";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { Link } from "react-router-dom";

import Style from "../../../styles/js/Styles.js";

import service from "../../../plas/services/shifter/service";

export default function Menu( { open, onExpand } ) {

  const style = Style();

  return (
    <div>
     { (service.canAdmin()) ? (
        <div>
          <ListItem button component={Link} to={"/shifter/events"}>
            <ListItemIcon>
              <ConfirmationNumberIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem} primary="Turnero" />
          </ListItem>
        </div>) : (null) 
     }
    </div>
    
  );
}
